export default __webpack_public_path__ + "static/media/Sample_File(hotel).dadc5303.xlsx";